import { render, staticRenderFns } from "./OrganizationGroupEdit.vue?vue&type=template&id=03977ca2&"
import script from "./OrganizationGroupEdit.vue?vue&type=script&lang=js&"
export * from "./OrganizationGroupEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports